import request, { gql } from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import {
  createQuotation,
  deteteQuotation,
  updateQuotationandproduct,
} from "../graphQL/graphMutation";

const CreateQuotationProduct = gql`
mutation createQuotationProduct($input: QuotationProductsInput!) {
    createQuotationproducts(input: $input) {
      success
    message
    }
  }
`;

export const addQuationFieldService = async (values, productvalues, userid) => {
 
  let status = false;
  let errormessage;
  try {
   
    const res = await request(BASEURL, createQuotation, values);
    const id = await res?.createQuotation?.data?.id;
    const data = productvalues.map((val) => ({
      user: userid,
      quotation: id,
      productName: val.productName?.value,
      SKU: val.SKU,
      HSNNumber: val.HSN,
      comments: val.comments,
      quantity: parseInt(val.quantity, 10), // Ensure quantity is a number
      rate: parseFloat(val.rate), // Ensure rate is a number
      tax: parseInt(val.tax?.value, 10), // Ensure tax is a number
      taxAmount: Math.round(val.taxAmount),
      margin: parseInt(val.margin, 10), // Ensure margin is a number
      marginValue: Math.round(val.marginAmount),
      amount: Math.round(val.amount),
      productDiscount: Math.round(val.discountAmount),
      productDiscountPercentage: parseInt(val.discount, 10),
      totalproductamount: Math.round(val.totalproductamount),
    }));

  

    for (const productInput of data) {
      try {
        const response = await request(BASEURL, CreateQuotationProduct, {
          input: productInput,
        });

      } catch (error) {
        console.error("Error creating product:", error);
        errormessage=error.response?.errors?.[0]?.message;
      }
    }

    status = true;
  } catch (err) {
    console.error(err.message, "quation error");
    status = false;
  }
  return {status,errormessage};
};

export const delteQuationService = async (id) => {
  let status = false;
  try {
    const res = request(BASEURL, deteteQuotation, { id: id });
    status = true;
  } catch (err) {
    console.error(err.message);
    status = false;
  }
  return status;
};

export const updateQuationService = async (values) => {
  let status = false;
  try {
    const res = await request(BASEURL, updateQuotationandproduct, {
      input: {
        ...values,
      },
    });
    status = true;
  } catch (err) {
    console.error(err.message);
  }
  return status;
};
